"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bot_chat_1 = require("../../messages/bot-chat");

var guest_chat_1 = require("../../messages/guest-chat");

var notification_1 = require("../../messages/notification");

var peer_1 = require("../../messages/peer");

var roster_1 = require("../../messages/roster");

var staff_presence_1 = require("../../messages/staff-presence");

var base_1 = __importDefault(require("../base"));

var methods_factory_1 = require("../methods-factory");

var StaffClient =
/*#__PURE__*/
function (_base_1$default) {
  _inherits(StaffClient, _base_1$default);

  function StaffClient(options) {
    var _this;

    _classCallCheck(this, StaffClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StaffClient).call(this, options));
    _this.acceptBotMessage = methods_factory_1.AcceptMessageFactory(bot_chat_1.BotMessage, 1);
    _this.acceptGuestChatHandled = methods_factory_1.AcceptMessageFactory(guest_chat_1.GuestChatHandled, 1);
    _this.acceptGuestChatRequest = methods_factory_1.AcceptMessageFactory(guest_chat_1.GuestChatRequest, 1);
    _this.acceptGuestChatRequestTimeout = methods_factory_1.AcceptMessageFactory(guest_chat_1.GuestChatRequestTimeout, 1);
    _this.acceptHandshake = methods_factory_1.AcceptMessageFactory(peer_1.PeerHello, 1);
    _this.acceptMessage = methods_factory_1.AcceptMessageFactory(peer_1.PeerMessage, 1);
    _this.acceptDepartmentNotification = methods_factory_1.AcceptMessageFactory(notification_1.DepartmentNotification, 1);
    _this.acceptPropertyNotification = methods_factory_1.AcceptMessageFactory(notification_1.PropertyNotification, 1);
    _this.acceptStaffNotification = methods_factory_1.AcceptMessageFactory(notification_1.StaffNotification, 1);
    _this.acceptStaffOnline = methods_factory_1.AcceptMessageFactory(staff_presence_1.StaffOnline, 1);
    _this.acceptStaffRoster = methods_factory_1.AcceptMessageFactory(roster_1.StaffRoster, 1);
    _this.unacceptGuestChatHandled = methods_factory_1.UnacceptMessageFactory(guest_chat_1.GuestChatHandled);
    _this.unacceptGuestChatRequest = methods_factory_1.UnacceptMessageFactory(guest_chat_1.GuestChatRequest);
    _this.unacceptGuestChatRequestTimeout = methods_factory_1.UnacceptMessageFactory(guest_chat_1.GuestChatRequestTimeout);
    _this.unacceptStaffOnline = methods_factory_1.UnacceptMessageFactory(staff_presence_1.StaffOnline);
    _this.unacceptStaffRoster = methods_factory_1.UnacceptMessageFactory(roster_1.StaffRoster);
    _this.unacceptHandshake = methods_factory_1.UnacceptMessageFactory(peer_1.PeerHello);
    _this.unacceptMessage = methods_factory_1.UnacceptMessageFactory(peer_1.PeerMessage);
    _this.sendBotMessage = methods_factory_1.SendMessageFactory();
    _this.sendGuestChatAnswer = methods_factory_1.SendMessageFactory();
    _this.sendGuestChatComplete = methods_factory_1.SendMessageFactory();
    _this.sendGuestChatDecline = methods_factory_1.SendMessageFactory();
    _this.sendStaffOnline = methods_factory_1.SendMessageFactory();
    _this.sendHandshake = methods_factory_1.SendMessageFactory();
    _this.sendMessage = methods_factory_1.SendMessageFactory();
    return _this;
  }

  return StaffClient;
}(base_1.default);

exports.StaffClient = StaffClient;
exports.default = StaffClient;